"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignHierarchyNodeSchema = void 0;
exports.hierarchyFromDesigns = hierarchyFromDesigns;
const zod_1 = require("zod");
function hierarchyFromDesigns(designs) {
    return Object.values(designs).map((d) => ({
        designId: d.designId,
        label: d.designName ?? d.designId,
        children: d.modelType === 'schematic' ?
            d.multiInstanceConfiguration?.instances?.map((i) => ({
                designId: d.designId,
                label: i.instanceName,
                instanceId: i.instanceId,
            }))
            : undefined,
    }));
}
exports.DesignHierarchyNodeSchema = zod_1.z.lazy(() => zod_1.z.object({
    designId: zod_1.z.string().optional(),
    label: zod_1.z.string(),
    instanceId: zod_1.z.string().optional(),
    children: zod_1.z.array(exports.DesignHierarchyNodeSchema).optional(),
}));
//# sourceMappingURL=DesignHierarchy.js.map